<p-card class="p-card container" [class.proposal-section--valid]="isCompleted && form.valid">
  @if (isDev && !isReadonly) {
    <p-button label="Simulate" class="btn--simulate" (onClick)="simulateFna()"></p-button>
  }

  <h3 i18n>Analyse des besoins d’assurance vie</h3>

  <form [formGroup]="form">
    <div class="layout__inner-card">
      <div class="layout--gap margin--bottom-medium">
        <div class="w-full">
          <label class="label-top" for="civil-status" i18n>État civil</label>
          <p-dropdown
            [options]="civilStatusOptions | emTranslate"
            [styleClass]="
              form.controls.civilStatus.invalid && form.controls.civilStatus.touched ? 'error--input' : ''
            "
            id="civil-status"
            [formControl]="form.controls.civilStatus"
            i18n-placeholder
            placeholder="Choisir"
            optionLabel="name"
            optionValue="value"></p-dropdown>
        </div>

        <div class="w-full">
          <label class="label-top" for="numChildren" i18n>Nombre d'enfants</label>
          <p-dropdown
            [options]="numChildrenOptions | emTranslate"
            [styleClass]="
              form.controls.numChildren.invalid && form.controls.numChildren.touched ? 'error--input' : ''
            "
            id="numChildren"
            [formControl]="form.controls.numChildren"
            i18n-placeholder
            placeholder="Choisir"
            optionLabel="name"
            optionValue="value"></p-dropdown>
        </div>

        <div class="w-full">
          <label class="label-top" for="youngestChildAgeInMonths" i18n>L'âge du plus jeune</label>
          <p-dropdown
            [options]="youngestChildOptions | emTranslate"
            [styleClass]="
              form.controls.youngestChildAgeInMonths.invalid && form.controls.youngestChildAgeInMonths.touched
                ? 'error--input'
                : ''
            "
            id="youngestChildAgeInMonths"
            [formControl]="form.controls.youngestChildAgeInMonths"
            i18n-placeholder
            placeholder="Choisir"
            optionLabel="name"
            optionValue="value"></p-dropdown>
        </div>
      </div>

      <div class="layout--gap margin--bottom-medium">
        <div class="w-full">
          <label class="label-top" for="salary" i18n>Salaire</label>
          <input
            [ngClass]="{
              'error--input': form.controls.salary.invalid && form.controls.salary.touched,
            }"
            [maxlength]="17"
            [thousandSeparator]="isFr ? ' ' : ','"
            [prefix]="form.controls.salary.value && !isFr ? '$' : ''"
            [suffix]="isFr ? ' $' : ''"
            mask="separator.0"
            i18n-placeholder
            placeholder="-- $"
            [formControl]="form.controls.salary"
            id="salary"
            pInputText />
        </div>

        <div class="w-full">
          <label class="label-top" for="mortgageAmount" i18n>Montant prêts hypothécaires</label>
          <input
            [ngClass]="{
              'error--input': form.controls.mortgageAmount.invalid && form.controls.mortgageAmount.touched,
            }"
            [maxlength]="17"
            [thousandSeparator]="isFr ? ' ' : ','"
            [prefix]="form.controls.mortgageAmount.value && !isFr ? '$' : ''"
            [suffix]="isFr ? ' $' : ''"
            mask="separator.0"
            i18n-placeholder
            placeholder="-- $"
            [formControl]="form.controls.mortgageAmount"
            id="mortgageAmount"
            pInputText />
        </div>

        <div class="w-full">
          <label class="label-top" for="debtAmount" i18n>Valeur des autres dettes</label>
          <input
            [ngClass]="{
              'error--input': form.controls.debtAmount.invalid && form.controls.debtAmount.touched,
            }"
            [maxlength]="17"
            [thousandSeparator]="isFr ? ' ' : ','"
            [prefix]="form.controls.debtAmount.value && !isFr ? '$' : ''"
            [suffix]="isFr ? ' $' : ''"
            mask="separator.0"
            i18n-placeholder
            placeholder="-- $"
            [formControl]="form.controls.debtAmount"
            id="debtAmount"
            pInputText />
        </div>
      </div>

      <div class="layout--gap margin--bottom-medium">
        <div class="w-full">
          <label class="label-top" for="monthlyDebtPaymentAmount" i18n
            >Paiement mensuel des dettes et/ou loyer
            <span
              [pTooltip]="tooltipContent"
              tooltipPosition="right"
              hideDelay="1000"
              class="pi pi-info-circle pb-1"></span
          ></label>
          <input
            [ngClass]="{
              'error--input':
                form.controls.monthlyDebtPaymentAmount.invalid &&
                form.controls.monthlyDebtPaymentAmount.touched,
            }"
            [maxlength]="17"
            [thousandSeparator]="isFr ? ' ' : ','"
            [prefix]="form.controls.monthlyDebtPaymentAmount.value && !isFr ? '$' : ''"
            [suffix]="isFr ? ' $' : ''"
            mask="separator.0"
            i18n-placeholder
            placeholder="-- $"
            [formControl]="form.controls.monthlyDebtPaymentAmount"
            id="monthlyDebtPaymentAmount"
            pInputText />
        </div>

        <div class="w-full">
          <label class="label-top" for="savingsAmount" i18n>Valeur totale des économies</label>
          <input
            [ngClass]="{
              'error--input': form.controls.savingsAmount.invalid && form.controls.savingsAmount.touched,
            }"
            [maxlength]="17"
            [thousandSeparator]="isFr ? ' ' : ','"
            [prefix]="form.controls.savingsAmount.value && !isFr ? '$' : ''"
            [suffix]="isFr ? ' $' : ''"
            mask="separator.0"
            i18n-placeholder
            placeholder="-- $"
            [formControl]="form.controls.savingsAmount"
            id="savingsAmount"
            pInputText />
        </div>

        <div class="w-full">
          <label class="label-top" for="heritageAmount" i18n>Montant à léguer en héritage</label>
          <input
            [ngClass]="{
              'error--input': form.controls.heritageAmount.invalid && form.controls.heritageAmount.touched,
            }"
            [maxlength]="17"
            [thousandSeparator]="isFr ? ' ' : ','"
            [prefix]="form.controls.heritageAmount.value && !isFr ? '$' : ''"
            [suffix]="isFr ? ' $' : ''"
            mask="separator.0"
            i18n-placeholder
            placeholder="-- $"
            [formControl]="form.controls.heritageAmount"
            id="heritageAmount"
            pInputText />
        </div>
      </div>

      <div class="layout--gap">
        <div class="w-full">
          <label class="label-top" for="jobCategoriesDropdown" i18n>Emploi</label>
          <div class="layout--row layout--gap">
            <p-dropdown
              class="w-full"
              [filter]="true"
              [options]="jobCategoryOptions | emTranslate"
              [styleClass]="
                form.controls.jobCategoryId.invalid && form.controls.jobCategoryId.touched
                  ? 'error--input'
                  : ''
              "
              [formControl]="form.controls.jobCategoryId"
              [virtualScroll]="true"
              [virtualScrollItemSize]="30"
              id="jobCategoriesDropdown"
              i18n-placeholder
              placeholder="Choisir"
              i18n-emptyFilterMessage
              emptyFilterMessage="Aucun résultat"
              filterBy="name"
              optionLabel="name"
              optionValue="value"></p-dropdown>
            <em-text-indicator
              [withTooltip]="true"
              i18n-tooltipText
              tooltipText="Classe de risque pour l'avenant invalidité"
              [text]="jobRiskClass"></em-text-indicator>
          </div>
        </div>
      </div>
    </div>
  </form>

  <h3 i18n>Protection(s) existante(s)</h3>
  <em-current-protections-section
    [currentProtections]="currentProtections"
    [protectionSearchResult]="protectionSearchResult"
    (formSubmitted)="handleCurrentProtectionSectionOutput($event)"
    (policyNumberChanged)="handlePolicyNumberChanged($event)"
    [isReadOnly]="isReadonly"></em-current-protections-section>

  @if (fna && fna.needs) {
    <em-needs-section [fna]="fna"></em-needs-section>
  }
</p-card>

<ng-template #tooltipContent>
  <p i18n
    ><strong>Créance admissible :</strong> Tout prêt à durée fixe dont la personne assurée est personnellement
    et légalement responsable à titre d’emprunteur ou de coemprunteur offert par une institution financière
    reconnue, incluant sans s’y limiter : tout prêt personnel (tel que prêt levier, prêt-auto, bateau, moto,
    véhicule récréatif (VR), étudiant, rénovation), carte de crédit, marge de crédit, bail de location, prêt
    et marge de crédit hypothécaire.</p
  >
  <p i18n
    >Lorsque la personne assurée n’a pas de prêt hypothécaire ou de marge de crédit hypothécaire, sera
    considéré comme créance admissible, le loyer mensuel de la personne assurée rencontrant les normes du
    tribunal administratif du logement d’un bail d’une durée minimale d’un an, payable à une personne physique
    ou morale sans lien de parenté ni d’affaires avec la personne assurée ou le titulaire.</p
  >
  <p i18n
    >Ne sont pas considérés comme des créances admissibles, les prêts entre individus et les prêts
    commerciaux.</p
  >
</ng-template>
